import { useEffect, useState, useCallback } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import FavouriteProduct from "./FavouriteProduct";
import { WrenchIcon, XIcon } from "../../../constants/Icons";

const ListFavouriteProduct = ({
  onClose,
  handleAddClick,
  listFavouriteProducts,
  loading,
  favouriteProductsData,
}) => {
  const [isFavouriteProductModel, setFavouriteProductModel] = useState(false);
  const [favouriteProducts, setFavouriteProducts] = useState(
    listFavouriteProducts || []
  );
  // const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const stopEventPropagation = (e) => e.stopPropagation();

  // const fetchFavouriteProducts = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await AxiosInstance.get("module/product/favourite");
  //     // Response shape: { results: [ { productIds: [...] } ] }
  //     const results = response.data?.results?.[0]?.productIds || [];
  //     setFavouriteProducts(results);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // // Fetch favourites on mount
  // useEffect(() => {
  //   fetchFavouriteProducts();
  // }, []);

  useEffect(() => {
    setFavouriteProducts(listFavouriteProducts || []);
  }, [listFavouriteProducts]);

  useEffect(() => {
    if (typeof favouriteProductsData === "function") {
      favouriteProductsData(favouriteProducts);
    }
  }, [favouriteProducts, favouriteProductsData]);

  // ⌨️ Close modal on ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  const visibleProducts = favouriteProducts.filter(
    (item) => item.productId !== null
  );

  // ⌨️ Keyboard navigation
  const handleKeyDown = useCallback(
    (e) => {
      if (!visibleProducts.length) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev < visibleProducts.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
      } else if (e.key === "Enter") {
        e.preventDefault();
        const selectedProduct = visibleProducts[selectedIndex];
        if (selectedProduct && selectedProduct.productId) {
          handleAddClick(selectedProduct.productId, selectedProduct);
        }
      }
    },
    [visibleProducts, selectedIndex, handleAddClick]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div>
      <div className="modal-backdrop show" onClick={onClose}></div>

      <div
        className="modal show"
        id="FavouriteProductModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        onClick={onClose}
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
          onClick={stopEventPropagation}
        >
          <div
            className="modal-content d-flex flex-column"
            style={{ height: "100%" }}
          >
            <div className="modal-header">
              <h6 className="modal-title">Favourite Products</h6>
              <div className="d-flex align-items-center fw-bold text-dark mb-0 ms-auto me-2">
                {favouriteProducts.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-sm btn-label-primary me-3"
                    onClick={() => setFavouriteProductModel(true)}
                  >
                    <WrenchIcon iClass={"me-1 fs-6"}/> Manage Favourite
                  </button>
                )}
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>
            </div>

            <div
              className="modal-body bg-light flex-grow-1"
              // style={{ minHeight: "400px" }}
            >
              <div className="card mb-0">
                <div className="card-body">
                  {loading ? (
                    <div className="text-center p-5">
                      <div className="spinner-border text-primary"></div>
                      <p className="text-muted mt-2">Loading favourites...</p>
                    </div>
                  ) : (
                    <div
                      className="table-responsive"
                      // style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                      <table className="table align-middle mb-0">
                        <thead className="table-light text-center">
                          <tr>
                            {/* <th style={{ width: "40px" }}>⇅</th> */}
                            <th>Barcode</th>
                            <th>Title</th>
                            <th>MRP</th>
                            <th>Discount</th>
                            <th>Sale Price</th>
                          </tr>
                        </thead>

                        <tbody>
                          {visibleProducts.length > 0 ? (
                            visibleProducts.map((item, index) => (
                              <tr
                                onClick={() => handleAddClick(index, item)}
                                className={`cursor-pointer  ${
                                  index === selectedIndex ? "table-primary" : ""
                                } `}
                              >
                                {/* <td className="text-center">
                                  <i className="bx bx-move-vertical fs-5 text-muted"></i>
                                </td> */}
                                <td className="text-center">
                                  <span className="badge rounded-pill bg-label-navy">
                                    {item.code || "-"}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="text-heading fw-medium text-wrap">
                                    {item.title || "-"}
                                  </span>
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.mrp || 0,
                                    "INR"
                                  )}
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.discount || 0,
                                    "INR"
                                  )}
                                </td>
                                <td className="text-center fw-medium">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.saleprice || 0,
                                    "INR"
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="p-5 text-center">
                                <p className="text-muted mb-3">
                                  No favourite products found
                                </p>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => setFavouriteProductModel(true)}
                                >
                                  <WrenchIcon iClass={"me-2"}/> Manage
                                  Favourite
                                </button>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn text-left btn-outline-secondary"
                onClick={onClose}
              >
                <XIcon/> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {isFavouriteProductModel && (
        <FavouriteProduct
          onClose={() => setFavouriteProductModel(false)}
          favouriteProductsData={(updatedList) => {
            setFavouriteProducts(updatedList);
          }}
          initialFavourites={favouriteProducts}
        />
      )}
    </div>
  );
};

export default ListFavouriteProduct;
